export default "__VITE_ASSET__CZZ8DVfc__"